{
  "name": "pmt-app",
  "version": "21.1.0",
  "scripts": {
    "ng": "ng",
    "start": "node --max_old_space_size=16384 ./node_modules/@angular/cli/bin/ng serve",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "audit": "npm audit --audit-level=high",
    "audit:fix": "npm audit fix",
    "audit:report": "npm audit --json > audit-report.json"
  },
  "private": true,
  "type": "module",
  "overrides": {
    "autoprefixer": "10.4.5"
  },
  "dependencies": {
    "@angular/animations": "^21.2.25",
    "@angular/cdk": "^21.2.10",
    "@angular/common": "^21.2.25",
    "@angular/forms": "^21.2.25",
    "@angular/localize": "^21.2.25",
    "@angular/platform-browser": "^21.2.25",
    "@angular/platform-browser-dynamic": "^21.2.25",
    "@angular/platform-server": "^21.2.25",
    "@angular/router": "^21.2.25",
    "@cosoft/fresh": "^5.9.3",
    "@microsoft/signalr": "8.0.7",
    "@ng-bootstrap/ng-bootstrap": "^20.0.0",
    "@popperjs/core": "2.11.8",
    "@progress/kendo-angular-buttons": "^21.1.0",
    "@progress/kendo-angular-charts": "^21.1.0",
    "@progress/kendo-angular-common": "^21.1.0",
    "@progress/kendo-angular-conversational-ui": "^21.1.0",
    "@progress/kendo-angular-dateinputs": "^21.1.0",
    "@progress/kendo-angular-dialog": "^21.1.0",
    "@progress/kendo-angular-dropdowns": "^21.1.0",
    "@progress/kendo-angular-excel-export": "^21.1.0",
    "@progress/kendo-angular-grid": "^21.1.0",
    "@progress/kendo-angular-icons": "^21.1.0",
    "@progress/kendo-angular-indicators": "^21.1.0",
    "@progress/kendo-angular-inputs": "^21.1.0",
    "@progress/kendo-angular-intl": "^21.1.0",
    "@progress/kendo-angular-l10n": "^21.1.0",
    "@progress/kendo-angular-label": "^21.1.0",
    "@progress/kendo-angular-layout": "^21.1.0",
    "@progress/kendo-angular-listview": "^21.1.0",
    "@progress/kendo-angular-menu": "^21.1.0",
    "@progress/kendo-angular-navigation": "^21.1.0",
    "@progress/kendo-angular-pager": "^21.1.0",
    "@progress/kendo-angular-pdf-export": "^21.1.0",
    "@progress/kendo-angular-popup": "^21.1.0",
    "@progress/kendo-angular-progressbar": "^21.1.0",
    "@progress/kendo-angular-scheduler": "^21.1.0",
    "@progress/kendo-angular-tooltip": "^21.1.0",
    "@progress/kendo-angular-treeview": "^21.1.0",
    "@progress/kendo-angular-upload": "^21.1.0",
    "@progress/kendo-angular-utils": "^21.1.0",
    "@progress/kendo-data-query": "^1.7.1",
    "@progress/kendo-date-math": "^1.5.15",
    "@progress/kendo-dateinputs-common": "^0.4.7",
    "@progress/kendo-drawing": "^1.23.0",
    "@progress/kendo-file-saver": "^1.1.2",
    "@progress/kendo-font-icons": "^4.5.0",
    "@progress/kendo-licensing": "^1.7.1",
    "@progress/kendo-recurrence": "^1.0.3",
    "@progress/kendo-svg-icons": "^4.5.0",
    "@progress/kendo-theme-default": "^12.1.0",
    "@telerik/kendo-intl": "^2.3.1",
    "buffer": "6.0.3",
    "clone": "2.1.2",
    "dayjs": "^1.11.23",
    "es-toolkit": "1.41.0",
    "jsondiffpatch": "^0.7.3",
    "jwt-decode": "3.1.2",
    "ng-click-outside": "9.0.0",
    "read-excel-file": "9.3.4",
    "rxjs": "^7.8.2",
    "zone.js": "0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^21.0.0",
    "@angular-eslint/schematics": "^21.0.0",
    "@angular/build": "^21.2.26",
    "@angular/cli": "^21.2.26",
    "@angular/compiler": "^21.2.25",
    "@angular/compiler-cli": "^21.2.25",
    "@angular/core": "^21.2.25",
    "@angular/language-service": "^21.2.25",
    "@eslint/js": "^10.0.0",
    "@types/node": "^26.6.0",
    "@vitest/coverage-v8": "^4.1.11",
    "angular-eslint": "^21.0.0",
    "eslint": "^10.0.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-rxjs-angular-x": "^1.0.0",
    "eslint-plugin-rxjs-x": "^1.0.0",
    "jsdom": "^30.0.0",
    "prettier": "^3.9.10",
    "typescript": "^5.9.3",
    "typescript-eslint": "^8.68.0",
    "vitest": "^4.1.11"
  }
}
